import { render } from "./pick_up_detail.vue?vue&type=template&id=a0c19eb0&scoped=true"
import script from "./pick_up_detail.vue?vue&type=script&lang=js"
export * from "./pick_up_detail.vue?vue&type=script&lang=js"

import "./pick_up_detail.vue?vue&type=style&index=0&id=a0c19eb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0c19eb0"]])

export default __exports__